import { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import LandingLayout from './LandingLayout';
import { CheckCircle } from 'lucide-react';

/**
 * Legacy / Stripe return URL: signup completed or checkout session finished.
 * Works without auth; primary actions are Login and Home.
 */
export default function SignUpSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = useMemo(() => searchParams.get('session_id')?.trim() || '', [searchParams]);

  return (
    <LandingLayout>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12">
        <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
            <CheckCircle
              className="h-14 w-14 text-green-600 dark:text-green-500 mx-auto mb-4"
              aria-hidden
            />
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
              You’re all set
            </h1>
            <p className="text-gray-600 dark:text-gray-400 text-sm mb-2">
              Your account is ready. Sign in to open the app and finish any remaining steps in
              Settings if needed.
            </p>
            {sessionId ? (
              <p className="text-xs text-gray-500 dark:text-gray-500 mb-8">
                Reference:{' '}
                <span className="font-mono break-all text-gray-700 dark:text-gray-300">{sessionId}</span>
              </p>
            ) : (
              <div className="mb-8" />
            )}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/login"
                className="inline-flex justify-center items-center px-6 py-3 bg-orange-600 hover:bg-orange-700 text-white rounded-lg font-semibold transition-colors"
              >
                Sign in
              </Link>
              <Link
                to="/"
                className="inline-flex justify-center items-center px-6 py-3 border border-gray-300 dark:border-gray-600 text-gray-800 dark:text-gray-200 rounded-lg font-semibold hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
              >
                Back to home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </LandingLayout>
  );
}
